import TBCH from "../static/tbch logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

export default function ForgotPass() {
  const forward = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    success: true,
  });

  useEffect(() => {
    document.title = "Forgot Password | TBCH";
  }, []);

  useEffect(() => {
    if (localStorage.getItem("current-user")) {
      forward("/");
    }
  }, [forward]);

  // user
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [secuKey, setSecuKey] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSecuKeyChange = (e) => {
    setSecuKey(e.target.value);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (!name.length || !password.length || !secuKey.length) {
      setMessage({
        ...message,
        message: "Important fields missing",
        success: false,
      });
      setTimeout(() => {
        setMessage({ ...message, message: "", success: false });
      }, 2000);
      return;
    }

    const data = {
      name: name.trim(),
      password: password.trim(),
      secu_key: secuKey.trim(),
    };

    axios
      .post("/_tbch-api/forget-password", data)
      .then((d) => {
        if (d.data.success) {
          setMessage({
            ...message,
            message: d.data.message,
            success: d.data.success,
          });
          setTimeout(() => {
            setMessage({ ...message, message: "", success: true });
            forward("/");
          }, 2000);
        } else {
          setMessage({
            ...message,
            message: d.data.message,
            success: d.data.success,
          });
          setTimeout(() => {
            setMessage({ ...message, message: "", success: false });
          }, 5000);
        }
      })
      .catch((e) => {
        setMessage({
          ...message,
          message: "Can't connect to server.",
          success: false,
        });
        setTimeout(() => {
          setMessage({ ...message, message: "", success: false });
        }, 5000);
      });
  };

  const sideBar = () => {
    if (sidebar) {
      return setSidebar(false);
    } else {
      return setSidebar(true);
    }
  };

  return (
    <div className="main">
      <nav
        className="mobile-nav"
        style={
          sidebar
            ? { transform: "translateX(0%)" }
            : { transform: "translateX(100%)" }
        }
      >
        <div className="close-button-wrap">
          <i class="lni lni-cross-circle" onClick={sideBar}></i>
        </div>
        <div className="choices">
          <span>
            <Link to="/">Return</Link>
          </span>
        </div>
        <img src={TBCH} alt="" />
        <div className="mark">
          <span>@ctxsoftwaresphilippines</span>
          <span>@charliecatxph</span>
          <span>
            Designed and developed by : Charl Concepcion, CEO of CTX Softwares
            Philippines
          </span>
        </div>
      </nav>
      <section className="landing-page bg-src">
        <div className="darken"></div>
        <nav className="nav-bar">
          <div className="container">
            <div className="logo">
              <img src={TBCH} alt="" />
            </div>
            <div className="navbar-buttons">
              <div className="button">
                <span>
                  <Link to="/">Return</Link>
                </span>
              </div>
            </div>
            <div className="burger-menu-btn" onClick={sideBar}>
              <i class="lni lni-menu"></i>
            </div>
          </div>
        </nav>
        <div className="container">
          <div className="wrap-form">
            <form onSubmit={handleLogin}>
              <div
                className="message-response"
                style={
                  message.success
                    ? { backgroundColor: "#2ecc71" }
                    : { backgroundColor: "#e74c3c" }
                }
              >
                <span>{message.message}</span>
              </div>
              <h1>Forgot Password:</h1>
              <label htmlFor="email">Name</label>
              <input
                type="text"
                name="email"
                id=""
                onChange={handleNameChange}
                required
                placeholder="myemail@mydomain.com"
              />
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id=""
                onChange={handlePasswordChange}
                required
                placeholder="password"
              />
              <label htmlFor="password">Secu-Key®</label>
              <input
                type="text"
                name="password"
                id=""
                onChange={handleSecuKeyChange}
                required
                placeholder="SECU_KEY"
              />
              <input type="submit" value="Login" class="submit-btn" />
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
